/* eslint-disable prettier/prettier */
//import { computed } from "vue"
import { useStore } from "vuex"

const modEducation = () =>{
    const store = useStore()
    const getAreaFormacion = async () => {
        const resp = await store.dispatch("mod_education/getAreaFormacion")
        return resp
   }
   const saveInstitution =  async (data) => {
    const resp = await store.dispatch("mod_education/saveInstitution",data)
     return resp
   }
   const getCourses = async (id_recinto_penitenciario) => {
    const resp = await store.dispatch("mod_education/getCourses", id_recinto_penitenciario)
    return resp
   }
   const editInstitution =  async (data) => {
    const resp = await store.dispatch("mod_education/editInstitution",data)
     return resp
   }
   const deleteInstitution =  async (id_institution) => {
    const resp = await store.dispatch("mod_education/deleteInstitution",id_institution)
     return resp
   }
   

   const saveCourse =  async (data) => {
    const resp = await store.dispatch("mod_education/saveCourse",data)
     return resp
   }
   const getInstitutions = async (departamento_centro_penitenciario) => {
    const resp = await store.dispatch("mod_education/getInstitutions", departamento_centro_penitenciario)
    return resp
   }
   const editCourse =  async (data) => {
    const resp = await store.dispatch("mod_education/editCourse",data)
     return resp
   }
   const deleteCourse =  async (id_asignatura) => {
    const resp = await store.dispatch("mod_education/deleteCourse",id_asignatura)
     return resp
   }

   const saveTeacher =  async (data) => {
    const resp = await store.dispatch("mod_education/saveTeacher",data)
     return resp
   }
   const getTeachers = async (id_recinto_penitenciario) => {
    const resp = await store.dispatch("mod_education/getTeachers", id_recinto_penitenciario)
    return resp
   }
   const deleteTeacherById = async (id_profesor) => {
    const resp = await store.dispatch("mod_education/deleteTeacherById", id_profesor)
    return resp
   }
   const deleteTeacherCourseById = async (id_profesor_asignatura, id_profesor) => {
    const resp = await store.dispatch("mod_education/deleteTeacherCourseById", {id_profesor_asignatura, id_profesor})
    return resp
   }


   const saveStudent =  async (data) => {
    const resp = await store.dispatch("mod_education/saveStudent",data)
     return resp
   }
   const getStudents = async (id_recinto_penitenciario) => {
    const resp = await store.dispatch("mod_education/getStudents", id_recinto_penitenciario)
    return resp
   }
   const editStudent =  async (data) => {
    const resp = await store.dispatch("mod_education/editStudent",data)
     return resp
   }
   const deleteStudentById = async (id_estudiante_asignatura) => {
    const resp = await store.dispatch("mod_education/deleteStudentById", id_estudiante_asignatura)
    return resp
   }





    const getSectionPpl =  async (id_recinto) => {
        const resp = await store.dispatch("visits/getSection",id_recinto)
         return resp
    }
    const getDataVisit = async (data) => {
        const resp = await store.dispatch("visits/getDataVisit",data)
        return resp
   }
    const valueToSearch = async (data) => {
        const resp = await store.dispatch("visits/valueToSearch",data)
        return resp
    }
    const valueToSearchVisit = async (data) => {
        const resp = await store.dispatch("visits/valueToSearchVisit",data)
        return resp
    }
    const register = async (data) => {
        const resp = await store.dispatch("visits/register",data)
        return resp
    }
    const visitsList = async (data) =>{
        const resp = await store.dispatch("visits/visitsList",data)
        return resp
    }
    const visitDetails = async (data) =>{
        const resp = await store.dispatch("visits/visitDetails",data)
        return resp
    }
    const CheckOutVisit = async (value) =>{
        const resp = await store.dispatch("visits/CheckOutVisit", value)
        return resp
    }
    const saveImage = async (value) =>{
        const resp = await store.dispatch("visits/saveImage", value)
        return resp
    }
    const seeImagesfromBack = async (id_img_visita) => {
        const resp = await store.dispatch("visits/seeImagesfromBack", id_img_visita)
        return resp
    }
    const deleteImageFromBack = async (id_img_visita) => {
        const resp = await store.dispatch("visits/deleteImageFromBack", id_img_visita)
        return resp
    }
    const checkRestriction = async (data) => {
        const resp = await store.dispatch("visits/checkRestriction", data)
        return resp
    }
    const normativeList = async () => {
        const resp = await store.dispatch("visits/normativeList")
        return resp
    }
    const registerRestriction = async (data) => {
        const resp = await store.dispatch("visits/registerRestriction",data)
        return resp
    }
    const restrictionsList = async (data) =>{
        const resp = await store.dispatch("visits/restrictionsList",data)
        return resp
    }
    const uploadFile = async(data)=>{
        const resp = await store.dispatch("visits/uploadFile", data)
        return resp
    }
    const uploadFileLiftRestriction = async(data)=>{
        const resp = await store.dispatch("visits/uploadFileLiftRestriction", data)
        return resp
    }
    const deleteFile = async(id)=>{
        const resp = await store.dispatch("visits/deleteFile", id)
        return resp
    }
    const deleteFileLiftRestriction = async(id)=>{
        const resp = await store.dispatch("visits/deleteFileLiftRestriction", id)
        return resp
    }
    const viewFile = async (data)=> {
        const resp = await store.dispatch("visits/viewFile", data)
        return resp
    }
    const viewFileLiftRestriction = async (data)=> {
        const resp = await store.dispatch("visits/viewFileLiftRestriction", data)
        return resp
    }
    const liftRestriction = async (data)=> {
        const resp = await store.dispatch("visits/liftRestriction", data)
        return resp
    }
    const registerLiftRestriction = async (data)=> {
        const resp = await store.dispatch("visits/registerLiftRestriction", data)
        return resp
    }
    const infoRestriction = async (data) => {
        const resp = await store.dispatch("visits/infoRestriction", data)
        return resp
    }
    const updateRestriction = async(data) => {
        const resp = await store.dispatch("visits/updateRestriction", data)
        return resp
    }
    const deleteRestriction = async(data) => {
        const resp = await store.dispatch("visits/deleteRestriction", data)
        return resp
    }
    const verifyRestriction = async(data) => {
        const resp = await store.dispatch("visits/verifyRestriction", data)
        return resp
    }
    const registerOnlyVisit = async(data) => {
        const resp = await store.dispatch("visits/registerOnlyVisit", data)
        return resp
    }
    return{
        getAreaFormacion,
        saveInstitution,
        getInstitutions,
        editInstitution,
        deleteInstitution,

        saveCourse,
        getCourses,
        editCourse,
        deleteCourse,

        saveTeacher,
        getTeachers,
        deleteTeacherById,
        deleteTeacherCourseById,

        saveStudent,
        getStudents,
        editStudent,
        deleteStudentById,

        getSectionPpl,
        getDataVisit,
        valueToSearch,
        valueToSearchVisit,
        register,
        visitsList,
        visitDetails,
        CheckOutVisit,
        saveImage,
        seeImagesfromBack,
        deleteImageFromBack,
        checkRestriction,
        normativeList,
        registerRestriction,
        restrictionsList,
        uploadFile,
        uploadFileLiftRestriction,
        viewFile,
        viewFileLiftRestriction,
        deleteFile,
        deleteFileLiftRestriction,
        liftRestriction,
        registerLiftRestriction,
        infoRestriction,
        updateRestriction,
        deleteRestriction,
        verifyRestriction,
        registerOnlyVisit
    }
    
};

export default modEducation